import * as React from 'react';
import { PublicPageWrapper } from '../../_pageWrappers/PublicPageWrapper';
import { LearningModuleList } from '../../_components/learning/LearningModuleList';

export function LearningModuleListPublicPage(): JSX.Element {

    return (
        <PublicPageWrapper partner='Joblife'>
            <LearningModuleList isPublic />
        </PublicPageWrapper>
    );
}